import { useQuery } from '@tanstack/react-query'

import { getAgenticPrompt } from 'services/agenticPrompts'

export const AGENTIC_PROMPT_QUERY_KEY = 'agenticPromptQuery'

function useAgenticPrompt(id) {
  const { isPending, data: prompt } = useQuery({
    queryKey: [AGENTIC_PROMPT_QUERY_KEY, id],
    queryFn: () => getAgenticPrompt(id),
    enabled: !!id,
    refetchOnWindowFocus: false,
    throwOnError: true,
  })

  return { prompt, isPending }
}

export { useAgenticPrompt }
